/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Page_Col_KbInputs */

const en_mk_cmp_page_col_kb = /** @type {(inputs: Mk_Cmp_Page_Col_KbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KerjaBareng`)
};

const id_mk_cmp_page_col_kb = /** @type {(inputs: Mk_Cmp_Page_Col_KbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KerjaBareng`)
};

/**
* | output |
* | --- |
* | "KerjaBareng" |
*
* @param {Mk_Cmp_Page_Col_KbInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_page_col_kb = /** @type {((inputs?: Mk_Cmp_Page_Col_KbInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Page_Col_KbInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_page_col_kb(inputs)
	return en_mk_cmp_page_col_kb(inputs)
});